import global from "global"
import React, { useEffect, useState } from "react"
import { useSelector } from "store/hooks"

interface CheckPermissionProps {
  children: React.ReactNode
  permissions: global.Permissions[]
}

const CheckPermission: React.FC<CheckPermissionProps> = ({
  children,
  permissions,
}) => {
  const data = useSelector((state) => state.user)
  const [hasPermission, setHasPermission] = useState(false)

  useEffect(() => {
    if (data?.role === "root") {
      setHasPermission(true)
      return
    }

    if (data?.permissions) {
      setHasPermission(
        permissions.some((permission) =>
          data?.permissions.includes(permission),
        ),
      )
    } else {
      setHasPermission(false)
    }
  }, [data, permissions])

  return <>{hasPermission ? children : null}</>
}

export default CheckPermission
